import SuppliersBar from './suppliers-bar';
export default SuppliersBar;